import { render, staticRenderFns } from "./CommunityCalendarMonth.vue?vue&type=template&id=3b00d1c2&scoped=true&"
import script from "./CommunityCalendarMonth.vue?vue&type=script&lang=ts&"
export * from "./CommunityCalendarMonth.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityCalendarMonth.vue?vue&type=style&index=0&id=3b00d1c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b00d1c2",
  null
  
)

export default component.exports